import { IError } from '@checkout/errors';
import { ICampaignSiteChangeSuccessPayload } from '@checkout/payloadTypes';
import { RootState } from '@checkout/state';
import { AxiosResponse } from 'axios';
import { Epic, ofType } from 'redux-observable';
import { fromPromise as fromPromise$ } from 'rxjs/observable/fromPromise';
import { of as of$ } from 'rxjs/observable/of';
import { catchError, flatMap, mergeMap } from 'rxjs/operators';
import { CampaignSiteChangeRequestAction, RootAction } from '../actions/actionTypes.d';
import ActionTypes from './../actions/actionTypes';
import { campaignSiteChangeSuccess, setErrors } from './../reducers/checkout';
import { rest } from './../utils/apiUtils';
import { logger } from './../utils/logger';

export const campaignSiteChangeEpic: Epic<RootAction, RootAction, RootState> =
  (action$, state$) => action$.pipe(
    ofType(ActionTypes.CAMPAIGN_SITE_CHANGE_REQUEST),
    mergeMap((action: CampaignSiteChangeRequestAction) => {
      return fromPromise$(rest.httpPut('/campaign-site', { uri: action.payload.uri }))
        .pipe(
            flatMap((response: AxiosResponse<ICampaignSiteChangeSuccessPayload>) => {
            return of$(campaignSiteChangeSuccess(response.data));
          }),
          catchError((error: IError) => {
            logger(error);
            return of$(setErrors(error));
          })
        );
    })
  );
